import { render, staticRenderFns } from "./KqStats.vue?vue&type=template&id=150baf06&scoped=true"
import script from "./KqStats.vue?vue&type=script&lang=js"
export * from "./KqStats.vue?vue&type=script&lang=js"
import style0 from "./KqStats.vue?vue&type=style&index=0&id=150baf06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150baf06",
  null
  
)

export default component.exports